@if (data?.title) {
  <sd-title [titleLevel]="data.titleLevel" customClass="brand--h3">
    {{data?.title}}
  </sd-title>
}
<div class="c__paragraphs {{isOpen ? 'is-open' : ''}} {{hasMultipleColumns ? 'has-multiple-columns' : ''}} {{lessThanLimit ? '' : 'has-overlay'}}">
  @if (isMobile) {
    @for (paragraph of data.paragraphs; track $index) {
      <section>
        @if (paragraph?.media) {
          <sd-banner
            [class]="(!isOpen && $index > numberOfParagraphToDisplay) ? 'is-visually-hidden' : ''"
            [media]="paragraph?.media"
          />
        }
        <sd-heading
          [customClass]="(!isOpen && $index > numberOfParagraphToDisplay) ? 'is-visually-hidden' : ''"
          [attr.aria-hidden]="(!isOpen && $index > numberOfParagraphToDisplay)"
          [heading]="paragraph?.heading"
          [textConfig]="textConfig"
          [titleLevel]="(data.titleLevel !== 6) ? data?.titleLevel + 1 : data?.titleLevel"
          [size]="sizeEnum.m"
          [titleThemesConfig]="themesEnum.dark"
          [idReadMore]="'paragraph ' + $index"
          [readMore]="$index === numberOfParagraphToDisplay"
          [limit]="limitLastParagraph"
          [events]="openHeadingReadMore.asObservable()"
          [tabindex]="(!isOpen && $index > numberOfParagraphToDisplay) ? -1 : ''"
          [isDescription]="(data.titleLevel + 1) > 6"
        />
      </section>
    }
  } @else {
    @for (paragraph of data?.paragraphs; track $index) {
      <section [class]="paragraph?.mediaPosition ? 'is-' + paragraph?.mediaPosition : 'is-right'">
        @if (paragraph?.media) {
          <sd-banner [media]="paragraph?.media" />
        }
        <sd-heading
          [heading]="paragraph?.heading"
          [textConfig]="textConfig"
          [titleThemesConfig]="themesEnum.dark"
          [titleLevel]="(data.titleLevel !== 6) ? data.titleLevel + 1 : data.titleLevel"
          [size]="sizeEnum.m"
          [isDescription]="((data.titleLevel + 1) > 6)"
        />
      </section>
    }
  }
</div>

@if (isMobile && !lessThanLimit && data?.hasReadMore) {
  <button
    type="button"
    class="c__toggle is-link"
    (click)="openReadMore()"
  >
    <span class="is-caption is-bold">{{ (!isOpen ? 'actions.readMore' : 'actions.showLess') | translate }}</span>
    <sd-icon [name]="isOpen ? 'icon-arrow-up' : 'icon-arrow-down'" [size]="iconSize.small" />
  </button>
}
